import { getLoggedError } from '@/lib/observability/logged-error';
import { reportClientError } from '@/lib/observability/report-client-error';

type Level = 'debug' | 'info' | 'warn' | 'error';

const LEVEL_ORDER: Record<Level, number> = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
};

const CURRENT =
  LEVEL_ORDER[
    (process.env.NEXT_PUBLIC_CLIENT_LOG_LEVEL as Level) ?? 'silent'
  ] ?? 100;

const enabled = (level: Level) => LEVEL_ORDER[level] >= CURRENT;

export const clog = {
  debug: (...args: any[]) => enabled('debug') && console.debug(...args),

  info: (...args: any[]) => enabled('info') && console.info(...args),

  warn: (...args: any[]) => enabled('warn') && console.warn(...args),

  // Reports even when console output is silenced (the production default).
  error: (...args: any[]) => {
    const { error, logMessage } = getLoggedError(args, 'clog.error called');
    reportClientError(error, {
      source: 'clog',
      properties: { log_message: logMessage },
    });
    return enabled('error') && console.error(...args);
  },
};
